import { useCallback, useEffect, useState } from "react";
import { api, ApiError, type KatalogParametrowDto } from "../lib/api.js";

/**
 * Lista parametrow oceny do pol wyboru, z czterema stanami (P-6): ladowanie, blad, gotowa.
 * Pusta lista to tez stan "gotowa" - serwer nie ma wtedy wlaczonego zadnego parametru, a ekran
 * pokazuje to jako pusty stan, nie jako blad.
 *
 * Uzywa tego formularz wgrywania, ekran zatwierdzania podzialu i okno ponownej oceny.
 */

export type StanKatalogu =
  | { stan: "ladowanie" }
  | { stan: "blad"; kod: string }
  | { stan: "gotowy"; katalog: KatalogParametrowDto };

export interface WynikKatalogu {
  katalog: StanKatalogu;
  /** Pobiera liste jeszcze raz. Poprzednia zostaje na ekranie do czasu odpowiedzi. */
  odswiez: () => void;
}

export function kodBleduApi(err: unknown): string {
  return err instanceof ApiError ? `${err.status} ${err.code}` : "brak połączenia z serwerem";
}

/**
 * @param aktywny false - nie pobieraj (np. dopoki okno z wyborem jest zamkniete). Zmiana na true
 *                uruchamia pobranie.
 */
export function useKatalogParametrow(aktywny = true): WynikKatalogu {
  const [katalog, setKatalog] = useState<StanKatalogu>({ stan: "ladowanie" });
  const [wersjaZadania, setWersjaZadania] = useState(0);

  useEffect(() => {
    if (!aktywny) return;
    let zywy = true;
    // Pierwsze pobranie i ponowienie po bledzie pokazuja spinner; odswiezenie przy gotowej
    // liscie jej nie chowa (S-7), wiec stan "ladowanie" ustawiamy tylko, gdy nie ma czego pokazac.
    setKatalog((poprzedni) => (poprzedni.stan === "gotowy" ? poprzedni : { stan: "ladowanie" }));

    api
      .parametryOceny()
      .then((dane) => {
        if (zywy) setKatalog({ stan: "gotowy", katalog: dane });
      })
      .catch((err: unknown) => {
        if (zywy) setKatalog({ stan: "blad", kod: kodBleduApi(err) });
      });

    return () => {
      zywy = false;
    };
  }, [aktywny, wersjaZadania]);

  const odswiez = useCallback(() => setWersjaZadania((n) => n + 1), []);
  return { katalog, odswiez };
}
